import { ManagementReportEntry } from '../../state/managementReport/types';
import { DataGridHandler } from '../DataGridFlexSales';

export interface ManagementGridContext {
  t: (key: string) => string;
}

const initialContext: ManagementGridContext = { t: () => '' };

export default (locale: Locale) => {
  const handler = new DataGridHandler<ManagementReportEntry, ManagementGridContext>(
    initialContext,
    locale
  );

  handler.addColumn({
    accessor: 'date',
    type: 'string',
    title: ({ t }) => t('management-report.columns.date'),
  });

  handler.addColumn({
    accessor: 'total_stores_qty',
    type: 'number',
    title: ({ t }) => t('management-report.columns.total_stores'),
  });

  handler.addColumn({
    accessor: 'stores_closed_ok_qty',
    type: 'number',
    title: ({ t }) => t('management-report.columns.stores_ok'),
  });

  handler.addColumn({
    accessor: 'unclosed_stores_qty',
    type: 'number',
    title: ({ t }) => t('management-report.columns.unclosed_stores'),
  });

  handler.addColumn({
    accessor: 'closed_stores_percentage',
    type: 'number',
    title: ({ t }) => t('management-report.columns.efficiency'),
    renderCell: val => `${val}%`,
  });

  handler.addColumn({
    accessor: 'conciliated_coupons_percentage',
    type: 'number',
    title: ({ t }) => t('management-report.columns.coupon_efficiency'),
    renderCell: val => `${val}%`,
  });

  handler.addColumn({
    accessor: 'conciliated_coupons_ok_qty',
    type: 'number',
    title: ({ t }) => t('management-report.columns.coupons_ok'),
  });

  handler.addColumn({
    accessor: 'unconciliated_coupons_qty',
    type: 'number',
    title: ({ t }) => t('management-report.columns.coupons_error'),
  });

  return handler;
};
